export default {
  id: '',
  fieldData: {
    fieldId: 0,
    fieldName: ''
  },
  clickFlag: false,
  chooseFlag: false,
  modalChooseFlag: false,
  modalId: null,
  modalPlantingId: null
}
